import React, { useEffect } from 'react';

const DonationWidget: React.FC = () => {
  useEffect(() => {
    // Listen for donation success events from DonorBox iframe
    const handleDonationMessage = (event: MessageEvent) => {
      // Only accept messages from DonorBox domain
      if (event.origin !== 'https://donorbox.org') {
        return;
      }

      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        if (data.event === 'donation_success') {
          console.log('Donation successful:', data);
          // Additional tracking or analytics can be added here
        }
      } catch (error) {
        console.error('Error parsing donation message:', error);
      }
    };

    window.addEventListener('message', handleDonationMessage);

    return () => {
      window.removeEventListener('message', handleDonationMessage);
    };
  }, []);

  return (
    <div id="donate" className="donation-widget-container py-5 bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center mb-4">
            <h2 className="display-5 fw-bold mb-3">Support Our Mission</h2>
            <p className="lead">
              Your donation helps us spread hope and save lives.
              Every contribution makes a difference in someone's journey to recovery.
            </p>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="donation-iframe-wrapper">
              <iframe
                src="https://donorbox.org/embed/stampoutsuicide-org?default_interval=o&amount=30"
                name="donorbox"
                frameBorder="0"
                scrolling="no"
                height="900"
                width="100%"
                style={{
                  maxWidth: '500px',
                  minWidth: '250px',
                  maxHeight: 'none',
                  margin: '0 auto',
                  display: 'block'
                }}
                allow="payment"
                title="Donation Form"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationWidget;
